let baseApiUrl = "https://bloggator-backend.onrender.com";

export default baseApiUrl;